// extracted by mini-css-extract-plugin
export default {"cell":"EditableCell_cell__n5CLX","button":"EditableCell_button__P004I"};